import React, { createContext, useState, useContext, useEffect } from "react";
import DialogSubscriptionPlan from "../components/dialogs/DialogSubscriptionPlan";

// 1. Create Context
const SidebarContext = createContext();

// 2. Provider Component
export const SidebarProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenUpgradeDialog, setIsOpenUpgradeDialog] = useState(false);

  // Device breakpoints
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setIsMobile(width < 768);
      setIsTablet(width < 1024);
    };

    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <SidebarContext.Provider
      value={{
        isOpen,
        toggleSidebar,
        isOpenUpgradeDialog,
        setIsOpenUpgradeDialog,
        isMobile,
        isTablet,
      }}
    >
      <DialogSubscriptionPlan
        open={isOpenUpgradeDialog}
        onClose={() => setIsOpenUpgradeDialog(false)}
      />
      {children}
    </SidebarContext.Provider>
  );
};

// 3. Custom Hook
export const useSidebar = () => {
  return useContext(SidebarContext);
};
